import React from "react";
import {Modal} from "react-spaceship-web";
import {history} from "./AppProvider";

export default class ShipmentProductAudit extends React.Component {
	render() {
		return (
			<div>
				<Modal className="ui modal tiny"
				       onShowToSetupForm={($modal) => {
					       let $has_product_ids = $modal.find('input[name="product_id"]').explorer({
						       url: process.env.REACT_APP_DOMAIN + '/api/product',
						       additionalData: () => {
							       return {
								       page: 1,
								       limit: 30,
								       exclude_product_id: $has_product_ids.explorer('get value')
							       }
						       },
						       key: 'product',
						       template: {
							       list: '<a class="item flex row">\n\t<span style="color: green;"><b>{{name}}</b></span>\n    <br><span style="color: #4c4c4c;">{{code}}</span>\n</a>',
							       selected: {
								       display_template: '<span>{{name}} <a href="/v2/products/{{id}}" target="_blank"><i class="icon linkify"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tstyle="font-size: 0.8rem;margin: 0;color: #646464;"></i></a></span>',
								       value: 'id',
								       placeholder: 'เลือกสินค้า'
							       }
						       }
					       });

					       if (this.props.product) {
						       $has_product_ids.explorer('set value', this.props.product);
					       }

					       $modal.find('form').form2('setup');
					       $modal.find('form').form2('submit', {
						       method: 'PUT',
						       url: process.env.REACT_APP_DOMAIN + '/api/v1',
						       beforeSent: (object) => {
							       if (!object.product_id) {
								       alert('ระบุสินค้า')
								       return false;
							       }

							       let status = '';
							       if (object.status) {
								       status = object.status.join(',')
							       }

							       let url = "/v2/shipments?has_product_ids="
								       + object.product_id
								       + "&order_by=done_date&limit=50&status=" + status
								       + (
									       object.is_request_excel_is_display_shipment_item_by_product_filter
									       ? "&is_request_excel_is_display_shipment_item_by_product_filter=1"
									       : ""
								       )
								       + "&random=" + window.Global.getRandomInt(1, 10000)
							       ;

							       history.push(url);
							       $modal.modal('hide');

							       return false;
						       },
						       loadingButton: $modal.find('.button.approve'),
						       onSuccess: () => {

						       }
					       });
				       }}>
					<div className="header">
						<h2>ตรวจสอบสินค้า</h2>
					</div>
					<div className="content">
						<form className="ui form" autoComplete="off">
							<div className="column">
								<div className={'ui message info small'}>
									<b>จุดประสงค์</b>: ช่วยติดตามประวัติความเคลื่อนไหวของสินค้าที่คุณต้องการทราบ
									<br/>
									<br/>
									<b>คำอธิบายขั้นตอน</b>
									<br/>
									- ระบบจะเรียงข้อมูลประวัติของสินค้า ตั้งแต่เริ่มต้น ถึงปัจจุบัน (ตามวันที่ดำเนินการ
									ไม่ใช่วันที่เอกสาร)
									<br/>
									- คุณสามารถเลือกดูประวัติข้อมูลย้อนหลังทีละรายการ หรือ อยากดูข้อมูลทั้งหมดจากการกดปุ่ม "รายงาน :
									แสดงเฉพาะสินค้าที่กรอง" หลังจากกดปุ่ม "ตรวจสอบสินค้า"
									<br/>
									<br/>
									หมายเหตุ: รายละเอียดใน "รายงาน : แสดงเฉพาะสินค้าที่กรอง"
									จะประกอบด้วยข้อมูลเพื่อช่วยในการตรวจสอบประวัติของสินค้านั้นๆดังนี้
									<br/>
									&nbsp;&nbsp;&nbsp;1. ยอด (+) นำเข้า<br/>
									&nbsp;&nbsp;&nbsp;2. ยอด (-) จ่ายออก<br/>
									&nbsp;&nbsp;&nbsp;3. ยอด คงเหลือ
								</div>
							</div>
							<div className="column field required" style={{margin: '1rem 0 0 0'}}>
								<label htmlFor="">เลือกสินค้าที่ต้องการตรวจสอบ</label>
								<input type="text"
								       name="product_id"
								/>
							</div>
							<div className="column field" style={{margin: '1rem 0 0 0'}}>
								<label htmlFor="">ตัวกรองสถานะ</label>
								<select className="ui dropdown fluid"
								        name="status[]"
								        multiple="multiple"
								        defaultValue={["done,complete"]}
								        data-onchange=""
								        data-form2_setup="true">
									<option value="">ทุกสถานะ</option>
									<option value="done,complete">สมบูรณ์ / เสร็จสิ้น</option>
									<option value="draft">ฉบับร่าง</option>
									<option value="void">ยกเลิก</option>
									<option value="wait_processing">รอดำเนินการ</option>
									<option value="processing">อยู่ระหว่างดำเนินการ / กำลังผลิต</option>
								</select>
							</div>
							<div className="column field" style={{margin: '1rem 0 0 0'}}>
								<div className="ui checkbox" data-form2_setup="true" data-state="create">
									<input id="is_request_excel_is_display_shipment_item_by_product_filter"
									       type="checkbox"
									       tabIndex="-1"
									       className="hidden"
									       name="is_request_excel_is_display_shipment_item_by_product_filter"/>
									<label htmlFor="is_request_excel_is_display_shipment_item_by_product_filter"><b>ฉันต้องการดาวโหลด "รายงาน : แสดงเฉพาะสินค้าที่กรอง" ทันที (Excel)</b></label>
								</div>
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div className="ui approve green right button">
									<i className="history icon" style={{height: 'initial'}}/> ตรวจสอบสินค้า
								</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}
